import { Button, Space, Tag, Typography } from 'antd';
import { Link } from 'react-router-dom';
import type { LegalConsentStatus, LegalDocumentType } from '../../types/legalConsent.types';

const { Text } = Typography;

interface LegalConsentStatusCardProps {
  status: LegalConsentStatus | null;
  onAcceptDocument?: (documentType: LegalDocumentType, version: string) => void;
  acceptingDocumentType?: LegalDocumentType | null;
}

const docConfig: Record<string, { label: string; path: string }> = {
  TERMS_OF_SERVICE: { label: 'Termos de Uso', path: '/legal/termos-de-uso' },
  PRIVACY_POLICY: { label: 'Política de Privacidade', path: '/legal/politica-de-privacidade' },
  COOKIE_POLICY: { label: 'Política de Cookies', path: '/legal/politica-de-cookies' },
};

export default function LegalConsentStatusCard({
  status,
  onAcceptDocument,
  acceptingDocumentType,
}: LegalConsentStatusCardProps) {
  if (!status) {
    return null;
  }

  return (
    <div>
      <Text strong style={{ display: 'block', marginBottom: 8 }}>Consentimento legal</Text>
      <Space direction="vertical" size={6} style={{ width: '100%' }}>
        {status.documents.map((doc) => {
          const config = docConfig[doc.type];
          return (
            <div key={doc.type} style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: 12 }}>
              <Link to={config.path} style={{ fontSize: 13 }}>{config.label}</Link>
              {doc.upToDate ? (
                <Tag color="green" style={{ margin: 0 }}>Aceito</Tag>
              ) : (
                <Button
                  size="small"
                  type="primary"
                  danger
                  loading={acceptingDocumentType === doc.type}
                  onClick={() => doc.activeVersion && onAcceptDocument?.(doc.type as LegalDocumentType, doc.activeVersion)}
                >
                  Aceitar
                </Button>
              )}
            </div>
          );
        })}
      </Space>
    </div>
  );
}
